import { render, staticRenderFns } from "./CollectionGroupList.vue?vue&type=template&id=c9e15de6"
import script from "./CollectionGroupList.vue?vue&type=script&lang=js"
export * from "./CollectionGroupList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports